import React, { Component } from "react";
import { PropTypes } from 'react';
import "./topHeader.scss";
import UnhappyCustomerPopup from "../AddBankDetails/unhappyCustomerPopup";
import { connect } from "react-redux";
import { clearAllLevel } from "../../SequenceHandler";
import { redirectToAnotherApplication } from "../../actions/crossSellApplicationActions";
import { isMobileChannel } from "../../utils/is.after";

export class TopHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { popupWindow: false, isLogout: false };

  }
  redirectAction =(redirect, e)=>{
    this.setState({ popupWindow: !this.state.popupWindow, isLogout: (e.target.value==='logOut') });
    let ssoReferrerUrl = this.props.offerPreFilled.ssoReferrer;
    if(redirect){
      clearAllLevel();
      if(isMobileChannel(this.props.offerPreFilled.channelSource)){
        this.props.redirectURL(ssoReferrerUrl);
      }else if(e.target.value==='logOut'){
        let ssoArray = ssoReferrerUrl.split( '/' );
        ssoArray[ssoArray.length-1]="logout";
        let logoutUrl = ssoArray.join('/');
        this.props.redirectURL(logoutUrl);
      }else if(e.target.value==='BacktoAccount'){
        this.props.redirectURL(ssoReferrerUrl);
      }

    }
  };

  logOut = () => {
    this.props.redirectURL(this.props.offerPreFilled.logoutUrl);
  };

  render() {
    let hideBackToAll =this.props.info.hideBackToAll || false;
    let pendFlow = this.props.offerPreFilled.pendFlow;
    const popup =(this.state.popupWindow?<UnhappyCustomerPopup isLogout={this.state.isLogout} togglePopupWindow={this.redirectAction} offerPreFilled={this.props.offerPreFilled}/>:null);
    return (
      <div className="container-fluid top-header-wrapper">
        <div className="container hidden-xs">
          <div className="row justify-content-md-center">
            <div className="col col-lg-10 col-md-11 col-sm-12">
              <div className="top_header row">
                <div className="col-6">
                  {!hideBackToAll?
                    <button data-track="custom_links" className="top-header-back" value="BacktoAccount" tabIndex="0" onClick={(e)=>{
                      this.redirectAction(false, e);
                    }} >Back to accounts</button>
                    :null
                  }

                </div>
                <div className="col-6">
                  <button data-track="custom-links" className="top-header-logout" value="logOut" tabIndex="0"
                    onClick={(e)=>{
                      this.redirectAction(false, e);
                    }} >Log out</button>
                </div>
                {popup}
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}


const mapDispatchToProps = { redirectURL: redirectToAnotherApplication };
export default connect('', mapDispatchToProps)(TopHeader);
